import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AddRequest, AddProjectErrors } from '@app/models/add-project';
import * as Objects from '@core/objects';
import * as fromAddProjectsState from '@app/store/state/add-project/add-project.state';
import * as fromAddProjectsActions from '@app/store/state/add-project/add-project.actions';

@Injectable({
    providedIn: 'root'
})
export class AddProjectService {
    constructor(private store: Store<fromAddProjectsState.AddProject>) {}

    submitAddProject(data: AddRequest) {
        this.store.dispatch(new fromAddProjectsActions.SubmitAddProject(data));
    }

    clear = () => this.store.dispatch(new fromAddProjectsActions.Clear());

    clearErrors = () => this.store.dispatch(new fromAddProjectsActions.ClearErrors());

    init = (workflowId: number, versionId: number | null) => 
        this.store.dispatch(new fromAddProjectsActions.InitAddProject(workflowId, versionId));

    selectData = (): Observable<AddRequest> => this.store.select(fromAddProjectsState.addProjectSelector);

    selectErrors = (): Observable<AddProjectErrors> => this.store.select(fromAddProjectsState.addProjectErrorsSelector);

    selectSavedProject = (): Observable<Objects.Request | null> => this.store.select(fromAddProjectsState.savedProjectSelector);

    selectCreatingNewProject = (): Observable<boolean> => this.store.select(fromAddProjectsState.creatingNewProjectSelector);

    selectSaved = (): Observable<boolean> => this.store.select(fromAddProjectsState.savedSelector);

    update = (property: Partial<AddRequest>) => this.store.dispatch(new fromAddProjectsActions.UpdateAddProject(property));
}